import * as React from 'react';
import { createSvgIcon } from '@fluentui/react-icons-mdl2';

const AdminDLogoInverse32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M761 999q0 44-9 91t-30 87-57 64-90 26q-18 0-36-1t-36-2V754q20-1 39-2t40-1q51 0 85 22t56 59 29 80 9 87zM64 273L1216 68v1912L64 1781V273zm312 1129q57 4 114 9t114 6q86 0 145-38t97-100 53-136 17-148q0-76-13-147t-46-127-91-89-146-34q-61 0-122 7t-122 13v784zm1030-377q0 26-10 49t-27 40-40 27-49 10V898q26 0 49 10t40 27 27 41 10 49zm610 84l-62 239-210-28q-17 26-35 50t-40 46l73 189-213 125-127-166q-60 13-122 15v-209q71 0 134-27t110-73 74-110 27-134q0-71-27-134t-74-110-110-74-134-27V467h5l79-178 238 63-27 203q53 34 99 80l186-71 124 213-166 127q6 28 9 56t4 57v10l185 82z" />
    </svg>
  ),
  displayName: 'AdminDLogoInverse32Icon',
});

export default AdminDLogoInverse32Icon;
